/* esm.sh - unhead@2.1.12/dist/shared/unhead._ybhDo-G */
export * from "/*unhead@2.1.12/esnext/dist/shared/unhead._ybhDo-G.mjs";
